



















import { onMounted, ref } from '@nuxtjs/composition-api';
import { useContent, useCurrentShop, useUser } from '~/composables';
import HTMLContent from '../components/HTMLContent';

export default {
  name: 'CromoFooter',
  components: {
    HTMLContent,
  },
  setup() {
    const { isAuthenticated } = useUser();
    const { loadBlocks } = useContent();
    const { get: getCurrent } = useCurrentShop();
    const blocks = ref([]);
    const blockLogo = ref();
    const blockReassurance = ref();
    const blockAdditional = ref();
    const blocksContent = ref([]);

    const commonIdentifiers = ['footer-additional', 'text-espace-part', 'popin-siret-content'];
    const disconnectIdentifiers = ['footer-tollens', 'footer-zolpan', 'footer-logo', 'footer-tollens-tools', 'footer-zolpan-services', 'footer-help', ...commonIdentifiers];
    const tollensIdentifiers = ['footer-tollens', 'footer-tollens-logo', 'footer-tollens-social', 'footer-tollens-reassurance', 'footer-tollens-tools', 'footer-tollens-services', 'footer-tollens-help', ...commonIdentifiers];
    const zolpanIdentifiers = ['footer-zolpan', 'footer-zolpan-logo', 'footer-zolpan-social', 'footer-zolpan-reassurance', 'footer-zolpan-tools', 'footer-zolpan-services', 'footer-zolpan-help', ...commonIdentifiers];

    onMounted(async () => {
      const isAuthenticatedUser = await isAuthenticated();
      if (!isAuthenticatedUser) {
        blocks.value = await loadBlocks({ identifiers: disconnectIdentifiers });
        blockLogo.value = blocks.value[2]?.content;
        blockAdditional.value = blocks.value[6]?.content;
        blocksContent.value = [
          { id: 'tollens', content: blocks.value[0]?.content, class: 'univers' },
          { id: 'zolpan', content: blocks.value[1]?.content, class: 'univers' },
          { id: 'tools', content: blocks.value[3]?.content, class: 'tools' },
          { id: 'services', content: blocks.value[4]?.content, class: 'services' },
          { id: 'help', content: blocks.value[5]?.content, class: 'help' }
        ];
      } else {
        let theme = localStorage.getItem('theme');
        if (!theme) {
          const current = await getCurrent();
          theme = current.current_univers === 'T' ? 'tollens' : 'zolpan';
        }
        blocks.value = await loadBlocks({ identifiers: theme === 'tollens' ? tollensIdentifiers : zolpanIdentifiers });
        blockLogo.value = blocks.value[1]?.content;
        blockReassurance.value = blocks.value[3]?.content;
        blockAdditional.value = blocks.value[7]?.content;
        blocksContent.value = [
          { id: 'univers', content: blocks.value[0]?.content, class: 'univers' },
          { id: 'tools', content: blocks.value[4]?.content, class: 'tools' },
          { id: 'servides', content: blocks.value[5]?.content, class: 'services' },
          { id: 'help', content: blocks.value[6]?.content, class: 'help' },
          { id: 'social', content: blocks.value[2]?.content, class: 'social' }
        ];
      }
    });

    return {
      blockLogo,
      blockReassurance,
      blockAdditional,
      blocksContent
    }
  },
};
